import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

// Fonction pour obtenir le rôle de l'utilisateur depuis le token
export const getUserRole = () => {
  const token = Cookies.get("access_token");
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.roles || [];
    } catch (error) {
      console.error("Échec du décodage du token", error);
      return [];
    }
  }
  return [];
};

// Fonction pour vérifier si l'utilisateur a au moins un des rôles requis
export const checkPermission = (requiredRoles, userRoles) => {
  if (!requiredRoles || !Array.isArray(userRoles)) return false;

  const required = requiredRoles.split("||").map((r) => r.trim());
  return required.some((role) => userRoles.includes(role));
};
